import { createApp, h } from 'vue';
import { store } from './System/Store/index';
import router from './System/Routes/RouterIndex';
import Boot from './Boot';
import * as Sentry from '@sentry/vue';

const app = createApp({
    render: () => h(Boot),
});

if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        app,
        dsn: 'https://53429cd810e34dff9c1d3c55abbd8ed0@o17205.ingest.sentry.io/4504247113678848',

        // This sets the sample rate to be 10%. You may want this to be 100% while
        // in development and sample at a lower rate in production
        replaysSessionSampleRate: 0.1,
        // If the entire session is not sampled, use the below sample rate to sample
        // sessions when an error occurs.
        replaysOnErrorSampleRate: 1.0,
        integrations: [
            new Sentry.BrowserTracing({
                routingInstrumentation: Sentry.vueRouterInstrumentation(router),
                tracePropagationTargets: ['portal.falagrett.se', 'test.portal.cervd.se', 'dev.portal.cervd.se', /^\//],
            }),
            new Sentry.Replay(),
        ],
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
    });
}

app.use(store);
app.use(router);

app.mount('#cervd-system');
